module.exports = __webpack_public_path__ + "static/media/racing.465c7f86.jpg";